<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 16 16"
  >
    <g fill="none" fill-rule="evenodd">
      <g fill="#6783B2">
        <path
          d="M13.5 6c.276 0 .5.224.5.5v7c0 1.381-1.119 2.5-2.5 2.5h-8C2.119 16 1 14.881 1 13.5v-7c0-.276.224-.5.5-.5s.5.224.5.5v7c0 .829.671 1.5 1.5 1.5h8c.829 0 1.5-.671 1.5-1.5v-7c0-.276.224-.5.5-.5zm-6 1c.276 0 .5.224.5.5v5c0 .276-.224.5-.5.5s-.5-.224-.5-.5v-5c0-.276.224-.5.5-.5zm3 0c.276 0 .5.224.5.5v5c0 .276-.224.5-.5.5s-.5-.224-.5-.5v-5c0-.276.224-.5.5-.5zm-6 0c.276 0 .5.224.5.5v5c0 .276-.224.5-.5.5s-.5-.224-.5-.5v-5c0-.276.224-.5.5-.5zm5-7c.276 0 .5.224.5.5V3h4.5c.245 0 .45.177.492.41L15 3.5c0 .276-.224.5-.5.5H.5C.224 4 0 3.776 0 3.5S.224 3 .5 3H5V.5c0-.245.177-.45.41-.492L5.5 0zM9 1H6v2h3V1z"
          transform="translate(-1376 -732) translate(280 544) translate(0 168) translate(1088 12) translate(8 8)"
        />
      </g>
    </g>
  </svg>
</template>

<script>
import VueTypes from 'vue-types';
export default {
  name: 'TrashIcon',
  props: {
    height: VueTypes.string.def('16'),
    width: VueTypes.string.def('16'),
  },
};
</script>

<style lang="scss"></style>
